import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getDocuments } from "../../redux/actions/actionDocument";
import { getClientes } from "../../redux/actions/actionClient";
import InformePruebaCard from "./informePruebaCard";
import { format, addDays } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InformePresupuestoPDF from "./informePresupuestoPDF";

import Swal from "sweetalert2";
import LoadingIcons from 'react-loading-icons'

export default function InformePrueba() {
  
  const dispatch = useDispatch();
  let documents = useSelector((state) => state.documents.allDocuments);  
  const [docAux, setDocAux] = useState();
  const [clienteInput, setClienteInput] = useState();  
  //const [checkSal, setCheckSal] = useState({ selectedOption: ALL_DOCUMENTS });   
  const [startDate] = useState(new Date());
  const [dateFind, setDateFind] = useState({
    desde: new Date(),
    hasta: new Date(),
  });
  const [totales, setTotales] = useState(false)
  const [verPDF, setVerPDF] = useState(false);

  
  useEffect(() => {
    dispatch(getDocuments());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getClientes());
  }, [dispatch]);

  console.log(documents);

        
    const handleCliente = (e) => {
        const { value } = e.target
        //console.log(value);                
        setClienteInput(value)
    }
    
    const handleDateDesde = (date) => {
      //console.log(date);
      setDateFind({
        ...dateFind,
        desde: date,
      });
    };
    const handleDateHasta = (date) => {
      setDateFind({
        ...dateFind,
      hasta: date,
    });
  };
  const handleDocumentsFind = () => {
    // console.log(dateFind.desde)
    // console.log(dateFind.hasta)
    // console.log(clienteInput);

    const busqueda = documents[0].filter(doc => {
      const coincidenciaCliente = clienteInput ? (doc.client_id ? doc.client_id.nameCompany.toLowerCase().includes(clienteInput.toLowerCase()) : null) : true;
      const rangoFechas = dateFind.desde && dateFind.hasta ? new Date(doc.dateSend) >= new Date(dateFind.desde) && new Date(doc.dateReception) <= new Date(dateFind.hasta) : true;
      return coincidenciaCliente && rangoFechas
    })
    
    if(busqueda.length === 0)Swal.fire("No hay resultados") 
    
    setDocAux(busqueda)
    setTotales(true)
    
  };

  const handleDateClean = () => {
    setDateFind({
      desde: new Date(),
      hasta: new Date()
    })
    setDocAux(documents[0])
    setTotales(false)
  }
    
  const suma = docAux && docAux.reduce((acum, docAux) => acum + parseInt(docAux.totalCoeficiente), 0)  
  //console.log(suma);

  const opendPDF = () => {
    setVerPDF(true);    
  };
  
  

  //console.log(documentsAux);
  //console.log(docAux);  
  //console.log(documents[0]);

  return (
    <div className="container bg-gray-900">
      
      <div className="">
        <div className="text-[20pt] h-10 ml-2 mt-4 pb-8 underline text-orange-500">
            Informes - Presupuesto
        </div>     

        
        <div className="flex flex-row h-24 pl-2 pt-2 mt-4 bg-cyan-900">
          <div className="flex flex-col w-40 text-[12px] font-bold text-yellow-500">
           
            
          </div>

          <div className="flex flex-col w-44 text-[12px] text-yellow-500 font-bold pl-2">
            
          </div>
          <div>
          <div className="flex flex-row text-[12px] w-56 font-bold text-yellow-500 pt-1 pl-5">
            <p className="mr-2">Buscar</p>
            <input
              className="border border-slate-700 rounded w-44 h-4 text-center bg-cyan-700 placeholder-yellow-400"
              type="text"
              placeholder="Nombre Cliente"
              onChange={handleCliente}
              //value={docs}
            />
          </div>          
          </div> 
          <div className="w-36 pl-2 ">
            <div className="flex">
              <label className="text-[12px] text-yellow-500 font-bold">
                Desde
              </label>
              <div className="w-12 text-[12px] pl-2">
                <DatePicker
                  className="w-20 pl-1 rounded bg-cyan-700 text-[12px] text-yellow-400 font-bold"
                  selected={startDate}
                  onChange={handleDateDesde}
                  value={
                    dateFind.desde ? format(dateFind.desde, "dd/MM/yyyy") : null
                  }
                />
              </div>
            </div>
            <div className="flex w-12 text-[12px] mt-1">
              <label className="text-[12px] text-yellow-500 font-bold">
                Hasta
              </label>
              <div className="w-12 text-[12px] pl-3">
                <DatePicker
                  className="w-20 pl-1 rounded bg-cyan-700 text-[12px] text-yellow-400 font-bold"
                  selected={startDate}
                  onChange={handleDateHasta}
                  value={
                    dateFind.hasta ? format(dateFind.hasta, "dd/MM/yyyy") : null
                  }
                />
              </div>
            </div>
            <div className="flex w-32">
            <button className="w-14 mt-2 text-[12px] text-yellow-500 font-bold bg-cyan-700 rounded border-2 border-cyan-500 hover:text-white" onClick={handleDocumentsFind}>
              Buscar
            </button>
            <button className="w-14 ml-2 mt-2 text-[12px] text-yellow-500 font-bold bg-cyan-700 rounded border-2 border-cyan-500 hover:text-white" onClick={handleDateClean}>
              Limpiar
            </button>
            </div>
          </div>
        </div>

        <div className="flex  text-orange-500">
          <div className="text-[14px] font-bold text-center w-12">
            Doc N°
          </div>
          <div className="text-[14px] font-bold text-left pl-4 w-72">
            Cliente
          </div>
          <div className="text-[14px] font-bold text-left pl-4 w-[200px]">
            Domicilio Evento
          </div>
          <div className="text-[14px] font-bold text-center w-20">
            Fecha de Salida
          </div>
          <div className="text-[14px] font-bold text-center w-20">
            Fecha de Entrada
          </div>
          <div className="text-[14px] font-bold text-center w-20">
            Total
          </div>
          <div className="text-[14px] font-bold text-center w-36">
            Facturas
          </div>
          <div className="text-[14px] font-bold text-center w-32">
            Estado
          </div>
        </div>
        <div className="container max-h-screen overflow-y-auto">
          {documents.length === 0 ? <div className="flex h-[400px] items-center justify-center"><LoadingIcons.Bars /></div> : 
        docAux 
          ? docAux.map((e) => {
              return (
                <div key={e._id}>
                  <InformePruebaCard
                    key={e._id}
                    id={e._id}
                    addressEvent={e.addressEvent}
                    name_client={e.client_id.nameCompany}
                    dateReception={e.dateReception}
                    dateSend={e.dateSend}
                    numberDocument={e.numberDocument}
                    totalCoeficiente={e.totalCoeficiente}
                    facturado={e.facturado}
                    cobrado={e.cobrado} 
                    facturasAsociadas={e.facturasAsociadas}                   
                  />
                </div>
              );
            })
          : documents[0] &&
            documents[0].map((e) => {
              return (
                <div key={e._id}>
                  <InformePruebaCard
                    key={e._id}
                    id={e._id}
                    addressEvent={e.addressEvent}
                    name_client={e.client_id.nameCompany}
                    dateReception={e.dateReception}
                    dateSend={e.dateSend}
                    numberDocument={e.numberDocument}
                    totalCoeficiente={e.totalCoeficiente}
                    facturado={e.facturado}
                    cobrado={e.cobrado}
                    facturasAsociadas={e.facturasAsociadas}
                  />
                </div>
              );
            })
            }
            {totales === true ?
            <div>
              <div className="flex flex-row justify-end mr-[150px] mt-8 text-orange-600 font-bold">
              <div className="w-[300px]">Total</div>
              <div className="">
              {suma}
              </div>
              </div>
              
              <button
                className="mt-12 ml-[150px] p-4 rounded font-semibold bg-sky-500 text-white hover:text-black w-[130px]" 
                onClick={opendPDF}
                >
                Imprimir
              </button>
              
              
              {verPDF ? (
             <div
              className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
              flex flex-col justify-center items-center"
             >
              <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                <button
                  className="text-black font-bold hover:text-white"
                  onClick={() => setVerPDF(false)}
                >
                  Cerrar
                </button>
              </div>
              <div>
              <InformePresupuestoPDF
                  key={docAux} 
                  docAux={docAux}
                  sumaTotal={suma}
              />
              </div>
             </div>
             ) : null}


             </div>
             : null
             }
             </div>
            

        </div>

    </div>
  );
}
